export const MAX_RANGE_DATA_BUFFER_SIZE = Math.floor(1024 * 1024 * 3.5);

export interface RowWriteOptions {
  insert?: boolean;
  rowNumberFormats?: (string | null)[];
}

export interface RowBlock {
  rows: any[];
  options: RowWriteOptions;
}

export class RangeDataBuffer {
  private rangeMap = new Map<Excel.Range, RowBlock[]>();
  private _size: number = 0;

  static calcRowSize(row: any[]) {
    return row.reduce((size, item) => size + String(item).length + 5, 6) + row.length;
  }

  addRowForRange(range: Excel.Range, row: any[], rowSize: number, options: RowWriteOptions = {}) {
    if (!this.rangeMap.has(range)) {
      this.rangeMap.set(range, [
        {
          rows: [],
          options,
        },
      ]);
    }

    const rangeRowBlocks = this.rangeMap.get(range)!;
    let lastRowBlock = rangeRowBlocks[rangeRowBlocks.length - 1];

    if (!!lastRowBlock.options.insert !== !!options?.insert) {
      lastRowBlock = {
        rows: [row],
        options: options,
      };
      rangeRowBlocks.push(lastRowBlock);
    } else {
      lastRowBlock.rows.push(row);
    }

    this._size += rowSize;
  }

  getRangeData(range: Excel.Range) {
    return this.rangeMap.get(range) || [];
  }

  reset() {
    this.rangeMap.clear();
    this._size = 0;
  }

  get ranges() {
    return Array.from(this.rangeMap.keys());
  }

  get size() {
    return this._size;
  }
}
